import React, { useRef, useState, useEffect } from 'react'
import { Button, IconButton, Typography } from '@mui/material'
import { useParams } from 'react-router-dom'
import { useHistory, useLocation } from "react-router-dom"
import { CopyToClipboard } from 'react-copy-to-clipboard'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import {
  LoaderDotted,
  MuiTextField,
  MuiButton,
  TourGuide,
  LayoutFooter,
  MuiImage,
} from '../../../../components'
import GenerativeService from '../../../../services/generative.service'
import { useGlobalStore } from '../../../../store'
import {
  getObjectAsArray,
  fakeDelay,
  generateStringToHtmlForAskIA,
  getImageUrl,
  getLogData,
  timeStampToDate,
  removeHtmlTags
} from '../../../../util'
import {
  GenerativeSearchIcon,
  IconArrowRight,
  IconCopyButton,
  IconThumbsUpButton,
  IconThumbsDownButton,
} from '../../../../assets/images/icons'
import Suggestions from './suggestions'

import {
  OuterWrapper,
  AskIaLayoutOuterWrapper,
  ChatOuterWrapper,
  ChatInnerWrapper,
  ServerChatWrapper,
  ClientChatWrapper,
  ServerContentWrapper,
  ClientContentWrapper,
  SearchBoxOuterWrapper,
  SearchWrapper,
  SearchInputBox,
  LinksWrapper,
  IconCloseOuterWrapper,
  IconButtonOuterWrapper,
  IconButtonWrapper,
  AllIconButton,
  StopTyping,
  LoaderInitiating,
  HeaderRightSection,
  HeaderLeftSection,
  DefaultSection,
  AnswerDevider,
  IADisclaimer,
  LoadingAnimationWrapper,
  Logo,
  AskIAWrapper,
} from './style'

import jsonData from './data'
import { ArrowBackIos, ArrowForwardIos } from '@mui/icons-material'
import ThemeButton from '../../../../components/themeButton/themeButton'
import Chatter from '../../../../components/chatter/chatter'
import IconQuestionRound from '../../../../assets/images/icons/icon-question-round'
import { loaderGif } from '../../../../assets/gif'
import IconLink from '../../../../assets/images/icons/icon-link'
import IconArrowForword from '../../../../assets/images/icons/icon-arrow-forword'
import IconAskIA from '../../../../assets/images/icons/icon-ask-IA'
import AskIaLayout from '../../../../layout/askIaLayout/askIaLayout'

const ReportGenerative = () => {
  const [loader, setLoader] = useState(false)
  const [chatData, setChatData] = useState([])
  const [typingStatus, setTypingStatus] = useState('typingDone')
  const [dataFromStorage, setDataFromStorage] = useState(false)
  const {
    setAskIaActiveState,
    setAskIAModalActive,
    setShowLhsMenu,
    isTourGuideActive,
    theme,
    user,
    company,
    projectIdValue,
    isAskIAModalActive
  } = useGlobalStore()
  const logoFolder = theme === 'dark' ? 'logos/theme-dark' : 'logos/default'
  const logoPath = getImageUrl(logoFolder, company?.CompanyLogo, 'svg')
  const [headerData, setHeaderData] = useState({})
  const [isFocus, setFocus] = useState(false)

  const [isServerStarting, setServerStarting] = useState(false)
  const interval = useRef(null)
  const form = useRef()
  const { id } = useParams()

  const history = useHistory()
  const location = useLocation()

  const scrollToBottomFunc = async (delay = 50, id = 'AskIaWrapper') => {
    await fakeDelay(delay)
    if (id === 'AskIaWrapper') {
      scrollToLast()
      // document.getElementById(id).scrollIntoView(false);
    } else {
      document.getElementById(id).scrollIntoView(true)
    }
  }

  const startServerToGetSuggestionList = (obj) => {
    setLoader(false)
    setServerStarting(true)
    // const ls_askIaStartServer = localStorage.getItem('askIaStartServer')
    // if( !isNaN(localStorage.getItem('askIaStartServer')) ){
    GenerativeService.askQuestionStartServerApi({}, true)
      .then((resp) => {
        const timer = 600
        setTimeout(() => {
          setServerStarting(false)
          localStorage.setItem('askIaStartServer', 'done')
          onSubmit(obj) // ACTION Looping functionality
        }, timer)
      })
      .catch((error) => {
        console.log('ERROR : ', error)
        setServerStarting(false)
      })
    // } else {
    //     setLoaderInitiating(false)
    //     onSubmit(obj) // ACTION Looping functionality
    // }
  }
  let myTimeout

  const onSubmit = (data) => {
    if (loader) return false

    setLoader(true)
    let check2minsFlag = true
    clearTimeout(myTimeout)

    formik.setFieldValue('userName', '')
    const question = {
      type: 'question',
      content: [{ text: data.query }],
      status: 'new',
    }
    updateAskIaDataFunc([...chatData, question])

    scrollToBottomFunc(0)
    setTimeout(() => {
      const wrap = document.querySelector('#AskIaWrapper')
      wrap.scrollTo(0, wrap.scrollHeight)
      scrollToBottomFunc()
      scrollToBottomFunc(500)
    }, 500)

    localStorage.setItem(
      'askIaLoading',
      JSON.stringify({ flag: true, payload: { query: data.query, studyId: id } })
    )

    setTimeout(() => {
      GenerativeService.askQuestionApi({ query: data.query, studyId: id })
        .then((resp) => {
          if (resp?.message === 'Internal server error') {
            // STATUS 502
            localStorage.removeItem('askIaStartServer')
            startServerToGetSuggestionList({ query: data.query })
          } else if (resp?.message === 'Request failed with status code 500') {
            // STATUS 500
            localStorage.removeItem('askIaStartServer')
            startServerToGetSuggestionList({ query: data.query })
          } else if (resp?.message === 'Endpoint request timed out') {
            // STATUS 504
            console.log('resp?.message 504 ---', resp?.message)
            // startServerToGetSuggestionList({query:data.query})
          } else if (check2minsFlag) {
            check2minsFlag = false
            if (JSON.parse(localStorage.getItem('askIaLoading')).flag) {
              const respData = resp || null
              if (respData?.file_names?.length > 0) {
                const insightsIds = respData?.file_names?.map((d) => {
                  const len = d.split('/').length - 1
                  const data = d.split('/')[len].split('.pdf')[0]
                  return data.split('_')[0]
                })
                const insightsIdsArray = []
                for (let i = 0; i < insightsIds.length; i++) {
                  if (!insightsIdsArray.includes(insightsIds[i])) {
                    insightsIdsArray.push(insightsIds[i])
                  }
                }

                const replaceAdditionalText = (txt) => {
                  const d1 = txt.indexOf('Answer:') !== -1 ? txt?.split('Answer:')[1] : txt
                  const d2 = d1.indexOf('answer:') !== -1 ? d1?.split('answer:')[1] : d1
                  return d2
                }

                // const payload = {studyId:id, insightsElementIds:insightsIdsArray.filter(f => f.indexOf('-') > 2 ).map(d => ({guid:d})) }
                const payload = {
                  insightsElementIds: insightsIdsArray
                    .filter((f) => f.indexOf('-') > 2)
                    .map((d) => ({ guid: d })),
                }

                GenerativeService.getInsightsElementsAcrossStudiesApi(payload)
                  .then((respSoap) => {
                    const res1 = getObjectAsArray(respSoap)?.[0]
                    const res2 = getObjectAsArray(res1.InsightsElement)

                    const regex = /(<([^>]+)>)/gi
                    const insightsArray = res2.map((i) => ({
                      InsightsElementId: i.InsightsElementId,
                      InsightsElementType: i.InsightsElementType,
                      title: i.Title,
                      parentTitle: i.ParentTitle,
                      heading:
                        i?.Heading?.replaceAll('&lt;//', '</')
                          ?.replaceAll('&lt;', '<')
                          ?.replaceAll('&gt;', '>')
                          ?.replace(regex, '')
                          ?.replaceAll('&nbsp;', ' ')
                          ?.replaceAll('&amp;', '&') || '',
                      EntityId: i.EntityId,
                      StudyId: i.StudyId,
                      TabId: i.TabId,
                      // type:'testing 1',
                      status: '',
                    }))

                    const addHtmlTags = (str) => {
                      return generateStringToHtmlForAskIA(str)
                    }

                    // const ans = (replaceAdditionalText(respData?.answer) || '').split('\n')
                    const ans = addHtmlTags(replaceAdditionalText(respData?.answer) || [])

                    // const id = `id_${id}_${question.content[0].text.replaceAll(' ','_').toLowerCase()}_${ans.flat(2).length}_`;
                    const _id = `id__${question.content[0].text.replaceAll(' ', '_').toLowerCase()}__${new Date().getTime()}`
                    const answer = {
                      type: 'answer',
                      raw:
                        replaceAdditionalText(respData?.answer)
                          .replaceAll('`', '')
                          .replaceAll('html', '')
                          .replaceAll('**', '')
                          .replaceAll('* ', '')
                          .replaceAll('*_ ', '') || '',
                      // content: [{text:'none'}, ...ans.map(a => ({text: a})) ],
                      content: [...(ans?.map((a) => ({ text: a })) || ans)],
                      insights: insightsArray,
                      showCopy: true,
                      question: question,
                      id: _id,
                      isLiked: null,
                    }
                    updateAskIaDataFunc([...chatData, question, answer])
                    setDataFromStorage(false)
                    check2minsFlag = false // NEW LINE ADDED

                    // const outputDiv = document.getElementById(_id)
                    const animationFunc = async () => {
                      // scrollToBottomFunc(1000)
                      await fakeDelay(100)
                      const outputDiv = document.getElementById(_id)
                      if (outputDiv) {
                        const contentWrapper = outputDiv.querySelectorAll('.animationHide')
                        if (contentWrapper?.length > 0) {
                          contentWrapper[0].classList.remove('animationHide')
                          contentWrapper[0].classList.add('animationfadeIn')
                          await fakeDelay(500)
                          scrollToBottomFunc(50) // this will add a delay & scrollToBottom both
                          contentWrapper[0].classList.add('animationfadeIn-1')
                          animationFunc()
                        }
                        if (contentWrapper.length <= 1) {
                          setLoader(false)
                        }
                      }
                    }

                    const findContentAndAddClassFunc = () => {
                      const outputDiv = document.getElementById(_id)
                      if (outputDiv) {
                        const contentWrapper = outputDiv.querySelector('.htmlContent')
                        if (contentWrapper) {
                          contentWrapper.classList.add('animationHide')
                          contentWrapper.classList.add('hidden')

                          const elements = contentWrapper.children
                          for (let i = 0; i < elements.length; i++) {
                            elements[i].classList.add('animationHide')
                          }

                          const elementLi = contentWrapper.querySelectorAll('li')
                          for (let i = 0; i < elementLi.length; i++) {
                            elementLi[i].classList.add('animationHide')
                          }

                          outputDiv.querySelector('.typeInsights').classList.add('animationHide')

                          scrollToBottomFunc(10, _id)
                          animationFunc()
                        } else {
                          setTimeout(() => findContentAndAddClassFunc(), 500)
                        }
                      } else {
                        setTimeout(() => findContentAndAddClassFunc(), 500)
                      }
                    }
                    findContentAndAddClassFunc()
                    setTimeout(() => {
                      document.getElementById(_id).querySelector('.htmlContent').classList.remove('hidden')
                    }, 2000)
                  })
                  .catch((error) => {
                    setLoader(false)
                    const resMessage = error
                    console.log('ERROR : ', resMessage)
                  })

                updateLogs(id, data.query, resp.answer)
                // } else if(respData?.message){
                //     const answer = {
                //         type: 'answer',
                //         raw: 'Please try again later or ask a different question.',
                //         content: [{text: 'Please try again later or ask a different question.'}],
                //         showCopy: false
                //     }
                //     updateAskIaDataFunc([...chatData, question, answer])
                //     setDataFromStorage(false)
                //     setLoader(false)
                //     updateLogs(id, data.query, resp.message)
              } else {
                const answer = {
                  type: 'answer',
                  raw: 'Please try again later or ask a different question.',
                  content: [{ text: 'Please try again later or ask a different question.' }],
                  showCopy: false,
                }
                updateAskIaDataFunc([...chatData, question, answer])
                setDataFromStorage(false)
                setLoader(false)
                const mess = isNaN(respData) ? respData?.message : 'timeout'
                updateLogs(id, data.query, mess)
              }
            }
          }
        })
        .catch((error) => {
          if (error?.message === 'Internal server error') {
            // STATUS 502
            localStorage.removeItem('askIaStartServer')
            startServerToGetSuggestionList({ query: data.query })
          }
          if (JSON.parse(localStorage.getItem('askIaLoading')).flag) {
            onSubmitCatch(chatData)
          }
        })
    }, 5000)

    myTimeout = setTimeout(() => {
      if (check2minsFlag) {
        onSubmitCatch(chatData)
        setLoader(false)
      }
    }, 150000)
  }

  const onSubmitCatch = (chatData) => {
    const localData = JSON.parse(localStorage.getItem('askIaLoading'))
    const data = localData.payload
    const id = localData.payload.studyId

    const answer = {
      type: 'answer',
      raw: 'Please try again later or ask a different question.',
      content: [{ text: 'Please try again later or ask a different question.' }],
      showCopy: false,
    }

    updateLogs(id, data.query, answer.content)

    const logs = {
      studyId: id,
      question: data.query,
      answer: answer.content,
    }
    GenerativeService.setStudyQuestionAnswerApi(logs)
      .then((resp) => {})
      .catch((error) => {})

    updateAskIaDataFunc([...chatData, data.query, answer])
    setLoader(false)
  }

  const updateLogs = (id, q, a, isLiked = null) => {
    const logs = { studyId: id, question: q, answer: a, isLiked: isLiked }
    GenerativeService.setStudyQuestionAnswerApi(logs)
      .then((resp) => {})
      .catch((error) => {})
  }

  const formik = useFormik({
    // validateOnChange: false,
    // validateOnBlur: false,
    initialValues: {
      userName: '',
    },
    validationSchema: Yup.object({
      //   userName: Yup.string().max(25).required('Keyword / Search is required'),
    }),
    onSubmit: (values) => {
      if (!loader) {
        //   if(!(loaderInitiating || loader)){
        const updatedValues = {
          query: values.userName,
        }
        onSubmit(updatedValues)
      }
    },
  })

  const showReport = (d) => {
    if (typingStatus !== 'typingDone' && chatData?.length > 1) return false
    const periodValue = getLogData('GetStudies', 'GetStudies', {}, { StudyId: d.StudyId })[0].Period
    setAskIaActiveState(
      `${d.InsightsElementId}___${d.InsightsElementType}___${d.title}___${d.EntityId || 'none'}___${periodValue}`
    )
  }

  const typingChanged = (d, index) => {
    if (d === 'typingStarted' && chatData[index].status !== 'typingStarted') {
      setTypingStatus(d)
    } else if (d === 'typingDone') {
      setTypingStatus(d)
      const chatDataTemp = chatData
      chatDataTemp[index].status = d
      updateAskIaDataFunc(chatDataTemp)

      const typeInsightsArr = document.querySelectorAll('.typeInsights')
      for (let i = 0; i < typeInsightsArr.length; i++) {
        typeInsightsArr[i].classList.add('show')
      }
    }
    setTimeout(() => {
      document.getElementById('AskIaWrapper').scrollIntoView(false)
    }, 500)
  }

  const closeAskIaDetailPage = () => {
      setAskIAModalActive(false)
      setShowLhsMenu('reportPage_showLhs')
      const params = new URLSearchParams(location.search);
      params.delete("askiaInsightsId");
  }

  const updateAskIaDataFunc = (data = jsonData) => {
    localStorage.setItem('AskIaData', JSON.stringify(data))
    setChatData(data)
    setTypingStatus('typingDone')
  }

  const copyButtonClicked = (id) => {
    document.getElementById(id).classList.add('copied')
    setTimeout(() => {
      document.getElementById(id).classList.remove('copied')
    }, 2000)
  }

  const likeDislikeButtonClicked = (data, like, index) => {
    updateLogs(id, data.question.content[0].text, data.raw, like)

    const localStorageArray = JSON.parse(localStorage.getItem('AskIaData')).map((d, _index) => {
      if (index === _index) {
        d.isLiked = like
      }
      return d
    })
    updateAskIaDataFunc(localStorageArray)
  }

  const stopLoadingFunc = () => {
    const els = document.querySelectorAll('.animationHide') ?? []
    els.forEach((el) => el.remove())
    const payload = JSON.parse(localStorage.getItem('askIaLoading')).payload
    localStorage.setItem('askIaLoading', JSON.stringify({ flag: false, payload: payload }))
    setLoader(false)
    // onSubmitCatch(chatData)
  }

  const stopTypingFunc = () => {
    clearInterval(interval.current)
    setTypingStatus('typingStop')

    const baseId = document.querySelector('#AskIaWrapper .answerWrap:last-of-type')
    const contentArray = []
    const data1 = baseId.querySelectorAll('p')
    let copyData = ''

    for (let i = 0; i < data1.length; i++) {
      if (data1[i].classList.contains('typing_pending')) {
        data1[i].classList.add('typing_deleted')
        data1[i].classList.remove('typing_pending')
      } else if (data1[i].querySelector('span')) {
        if (data1[i].classList.contains('typing')) {
          data1[i].classList.remove('typing')
        }
        const d = data1[i].querySelector('span').innerHTML
        contentArray.push({ text: d.replaceAll('&amp;', '&') }) // json
        copyData = copyData + d // copy data
      }
    }

    const askIaData = JSON.parse(localStorage.getItem('AskIaData')) // AskIaData
    askIaData[askIaData.length - 1].content = contentArray
    askIaData[askIaData.length - 1].raw = copyData.replace('Answer:', '')
    askIaData[askIaData.length - 1].status = 'typingDone'
    askIaData[askIaData.length - 1].isLiked = null

    const wrap = document.querySelector('#AskIaWrapper')
    wrap.classList.add('stopTypingLoader')
    scrollToLast()
    // setChatData(askIaData)
    setTimeout(() => {
      updateAskIaDataFunc(askIaData)
      // localStorage.setItem('AskIaData', JSON.stringify(askIaData))
      // setChatData(askIaData)
      // const wrap = document.querySelector('#AskIaWrapper')
      // wrap.scrollTo(0, wrap.scrollHeight);

      setTimeout(() => {
        wrap.classList.remove('stopTypingLoader')
      }, 500)

      setTimeout(() => {
        scrollToLast()
      }, 500)
    }, 2000)
  }

  const suggestionClickedFunc = (str) => {
    onSubmit({ query: str })
    setTimeout(() => {
      scrollToLast()
    }, 500)
  }

  const scrollToLast = () => {
    const el = document.querySelector('#innerWrapper')
    if (el) {
      el.scrollTo(0, el.scrollHeight)
    }
  }

  const onEnterPress = (e) => {
    scrollToLast()
    if (e.charCode == 13 && e.shiftKey == false) {
      e.preventDefault()
      formik.handleSubmit()
    }
  }

  const converToPlainHTML = (e) => {
    let val = ''
    for (let i = 0; i < e.length; i++) {
      if (e[i].text) {
        val = val + e[i].text
      }
    }
    return val
  }

  useEffect(() => {
    document.getElementById('userName').focus()
    setTimeout(() => {
      scrollToLast()
    }, 2000)
  }, [])

  useEffect(() => {
    const params = new URLSearchParams(location.search)
    const insightId = params.get('askiaInsightsId')
    if(insightId){
      setTimeout(() => {
        const d = JSON.parse(window.localStorage.getItem('askIaInsightsId'))
        const periodValue = getLogData('GetStudies', 'GetStudies', {}, { StudyId: d.StudyId })[0].Period
        setAskIaActiveState(
          `${d.InsightsElementId}___${d.InsightsElementType}___${d.title}___${d.EntityId || 'none'}___${periodValue}`
        )
      }, 1200)
    } 
  }, [])

  useEffect(() => {
    const askIaData = JSON.parse(localStorage.getItem('AskIaData'))
    if (askIaData?.length > 0) {
      setDataFromStorage(true)
      setChatData(askIaData)
      setTypingStatus('typingDone')

      scrollToLast()
    } else {
      updateAskIaDataFunc()
    }

    getHeaderInfo()
  }, [])

  const getHeaderInfo = () => {
    const headerLogData = projectIdValue.ProjectId
      ? getLogData('GetProjects', 'GetProjects', {}, { ProjectId: projectIdValue.ProjectId })[0]
      : {}

    const headerObj = {
      // isFreezed: projectIdValue.IsFreezed,
      // isPublished: projectIdValue.IsPublished,
      studyId: projectIdValue.StudyId,
      brandName: headerLogData?.BrandName || headerLogData?.CategoryName || '',
      breadCrumb: headerLogData?.ProjectType || '',
      projectType: `${headerLogData?.ProjectType}${headerLogData?.ProjectType ? ',' : ''} ${headerLogData?.MarketName}`,
      // subTitle: `${headerLogData.MarketName} | ${headerLogData.ProjectFrequency} | ${projectIdValue.Period}`,
      subTitle: projectIdValue.Period,
      lastUpdated: timeStampToDate(projectIdValue?.ModifiedDate || ''),
    }
    setHeaderData(headerObj)
  }

  const ActionButtons = () => {
    return (
      <>
        <ThemeButton />
        <Button
          className='button-back'
          size='small'
          onClick={() => closeAskIaDetailPage()}
          variant='outlined'
        >
          <ArrowBackIos fontSize='8px' />
          <Typography sx={{ fontSize: '14px', fontWeight: 400 }}>Back</Typography>
        </Button>
      </>
    )
  }

  return (
    <>
      <AskIaLayout actionButtons={ActionButtons()}>
        <AskIaLayoutOuterWrapper id='innerWrapper' className={loader ? 'loading-page' : ''}>
        <AskIAWrapper>
          <IconAskIA fill={theme === 'light' ? '#000000' : '#4A5056'} />
        </AskIAWrapper>

          <DefaultSection>
            <GenerativeSearchIcon />
            <Typography className='hello-this'>Hello, this is your Insights Assistant</Typography>
            <Typography className='how-help'>How can I help you today?</Typography>
            <Suggestions
              chatData={chatData}
              disabledLinks={loader || typingStatus !== 'typingDone'}
              parentLoader={loader}
              typing={typingStatus}
              suggestionClicked={(d) => suggestionClickedFunc(d)}
              serverStartEvent={(d) => setServerStarting(d)}
            />
          </DefaultSection>

          <ChatOuterWrapper id='AskIaOuterWrapper'>
            <ChatInnerWrapper id='AskIaWrapper'>
              {chatData.map((d, index) => {
                if (d.type === 'answer') {
                  return (
                    <>
                      <ServerChatWrapper className='answerWrap' key={index} id={d.id}>
                        <Chatter userName={user?.UserName} />
                        <ServerContentWrapper className='ServerContentWrapper'>
                          <div
                            className='htmlContent'
                            dangerouslySetInnerHTML={{ __html: converToPlainHTML(d.content) }}
                          />
                          {d?.insights && (
                            <LinksWrapper
                              className={`typeInsights ${d.status === 'typingDone' ? 'show' : ''} ${typingStatus !== 'typingDone' && chatData?.length > 1 ? 'disable' : ''}`}
                            >
                              <Typography
                                sx={{
                                  display: 'flex',
                                  fontWeight: 600,
                                  fontSize: '14px',
                                  width: '100%',
                                  marginTop: '5px',
                                  paddingBottom: '0 !important',
                                  color: (theme) => theme.palette.text.primaryTemp,
                                }}
                              >
                                Here are some resources you might find useful:
                              </Typography>

                              {d.insights.map((e, j) => {
                                return (
                                  <LinkWithArrow
                                    key={j}
                                    title={e.heading || e.parentTitle || e.title}
                                    onClick={() => {
                                      showReport(e)
                                    }}
                                  />
                                )
                              })}
                            </LinksWrapper>
                          )}
                        </ServerContentWrapper>
                      </ServerChatWrapper>
                      <IconButtonOuterWrapper className='likeButtons'>
                        {d.showCopy && <div></div>}
                        {d.showCopy && (
                          <IconButtonWrapper>
                            {d.isLiked && (
                              <Typography className='thanks'>Thanks for your feedback!</Typography>
                            )}
                            {d.isLiked === false && (
                              <Typography className='thanks'>
                                Apologies for the error in the answer. We're on it and will rectify it
                                as soon as possible.
                              </Typography>
                            )}
                            <AllIconButton
                              id={`idThumbsUpButton_${index}`}
                              className={`btnThumbsUp isLiked_${d.isLiked}`}
                              color='primary'
                              onClick={() => likeDislikeButtonClicked(d, true, index)}
                            >
                              <IconThumbsUpButton
                                isClicked={d.isLiked}
                                fill={theme === 'light' ? '#fff' : '#000'}
                              />
                            </AllIconButton>
                            <AllIconButton
                              id={`idThumbsDownButton_${index}`}
                              className={`btnThumbsDown isLiked_${d.isLiked}`}
                              color='primary'
                              onClick={() => likeDislikeButtonClicked(d, false, index)}
                            >
                              {d.isLiked === null ? (
                                <IconThumbsDownButton
                                  isClicked={false}
                                  fill={theme === 'light' ? '#fff' : '#000'}
                                />
                              ) : (
                                <IconThumbsDownButton
                                  isClicked={!d.isLiked}
                                  fill={theme === 'light' ? '#fff' : '#000'}
                                />
                              )}
                            </AllIconButton>
                            <AllIconButton
                              id={`idCopyButton_${index}`}
                              className='btnCopy'
                              onClick={() => copyButtonClicked('idCopyButton_' + index)}
                            >
                              <IconCopyButton isDark={theme === 'dark'} />
                              <CopyToClipboard text={removeHtmlTags(d.raw)}>
                                <span>{removeHtmlTags(d.raw)}</span>
                              </CopyToClipboard>
                            </AllIconButton>
                          </IconButtonWrapper>
                        )}
                      </IconButtonOuterWrapper>
                      {chatData.length > index + 1 && <AnswerDevider />}
                    </>
                  )
                } else if (d.type === 'question') {
                  return (
                    <ClientChatWrapper className='questionWrap' key={index}>
                      <Chatter isQuestion userName={user.UserName} />
                      <ClientContentWrapper className='question-content'>
                        {d.content.map((c, j) => {
                          return (
                            <p key={j} className='notType'>
                              {c.text}
                            </p>
                          )
                        })}
                      </ClientContentWrapper>
                    </ClientChatWrapper>
                  )
                }
              })}
            </ChatInnerWrapper>
          </ChatOuterWrapper>

          <SearchBoxOuterWrapper>
            {loader && (
              <StopTyping onClick={() => stopLoadingFunc()} variant='contained'>
                <LoadingAnimationWrapper>
                  <img src={loaderGif} alt='loader' />
                </LoadingAnimationWrapper>
                Stop Responding
              </StopTyping>
            )}

            <SearchWrapper>
              <form ref={form} onSubmit={formik.handleSubmit}>
                <SearchInputBox className={isFocus ? 'input-focus' : ''}>
                  <MuiTextField
                    id='userName'
                    fullWidth
                    name='userName'
                    onChange={formik.handleChange}
                    type='text'
                    value={formik.values.userName}
                    multiline
                    onFocus={() => setFocus(true)}
                    onBlur={() => setFocus(false)}
                    placeholder={
                      chatData.length
                        ? 'Type a new question... (previous messages are not linked)'
                        : 'Ask anything related to the study'
                    }
                    disabled={isServerStarting || loader || typingStatus !== 'typingDone'}
                    onKeyPress={(e) => onEnterPress(e)}
                  />
                  <IconQuestionRound fill={theme === 'light' ? '#686867' : '#D0D0CE'} />
                  <IconButton
                    onClick={formik.handleSubmit}
                    disabled={formik.values.userName.length < 3 || isServerStarting || loader}
                    className='send-button'
                  >
                    <IconArrowRight
                      rotate={formik.values.userName.length > 2 ? '-90deg' : '0'}
                      fill={formik.values.userName.length > 2 ? '#fff' : '#ADADAC'}
                      isDefault={false}
                    />
                  </IconButton>
                </SearchInputBox>
              </form>
              <IADisclaimer>
                Ask IA only provides answers based on our research and analysis.
              </IADisclaimer>
            </SearchWrapper>
          </SearchBoxOuterWrapper>
        </AskIaLayoutOuterWrapper>
      </AskIaLayout>
    </>
  )
}

export default ReportGenerative

const LinkWithArrow = ({ title, onClick }) => {
  const { theme } = useGlobalStore()
  return (
    <MuiButton
      variant='outlined'
      sx={{
        borderRadius: '20px',
        paddingRight: '0 10px',
        marginTop: '10px',
        gap: '10px !important',
        fontSize: '12px',
        background: theme === 'dark' ? '#454545' : '#F2F8FF',
        marginRight: '8px',
      }}
      onClick={onClick}
    >
      <IconLink fill={theme === 'dark' ? '#FF8C01' : '#095BBD'} />
      {title}
      <IconArrowForword fill={theme === 'dark' ? '#95A1AC' : '#686867'} />
    </MuiButton>
  )
}
